import React from 'react';
import {observer} from 'mobx-react';
import PlaceIcon from '@mui/icons-material/Place';
import DeliverySiteOnboardingRequestFormScreen from '../../../components/forms/DeliverySiteOnboardingRequestFormScreen';
import FormSetPanel from '../../../components/FormSetPanel';
import useFeature from '../../../useFeature';
import {useApplication} from '../../../ApplicationProvider';
import FormSkeleton from "../../../components/FormSkeleton";
import CompletionProgressBar from "../../../components/CompletionProgressBar";
import {Box} from "@mui/material";

function DeliverySitesOnboardingRequestsPanel({ generalFeature }) {
    const application = useApplication();
    const feature = useFeature(() => generalFeature.features['CustomerOnboardingDeliverySitesOnboardingRequestsFeature'])

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const renderDeliverySiteOnboardingRequest = (deliverySite) => {
        return (
            <>
                <Box mb={2}>
                    <CompletionProgressBar form={deliverySite} />
                </Box>
                <DeliverySiteOnboardingRequestFormScreen
                    deliverySite={deliverySite}
                    jurisdictionsOptions={feature.jurisdictionsFieldOptions()}
                    zonesOptions={feature.zonesFieldOptions()}
                    frequenciesOptions={feature.frequenciesFieldOptions()}
                    zonesFrequencyForDeliverySite={(deliverySite) => feature.chosenZoneFrequency(deliverySite)}
                />
            </>
    );
    };

    if (!isFeatureReady(feature)) {
        return (
            <FormSkeleton
                rows={3}
                fieldsPerRow={3}
            />
        );
    }

    return (
        <Box p={3} display="flex" flexDirection="column" gap={3}>
            <CompletionProgressBar form={feature.deliverySitesOnboardingRequestsFormSet} />
            <FormSetPanel
                formSet={feature.deliverySitesOnboardingRequestsFormSet}
                addButtonTitle="Agregar Punto de Entrega"
                addButtonIcon={<PlaceIcon fontSize="small"/>}
                onAddItem={() => feature.addDeliverySiteOnboardingRequest()}
                onRemoveItem={(deliverySiteId) => feature.removeDeliverySiteOnboardingRequest(deliverySiteId)}
                renderItemContent={renderDeliverySiteOnboardingRequest}
                getItemTitle={(deliverySite) => {
                    const name = deliverySite.name();
                    return name || 'Nuevo punto de entrega';
                }}
                emptyStateTitle="No hay puntos de entrega agregados"
                emptyStateDescription="Haz clic en 'Agregar Punto de Entrega' para comenzar"
                emptyStateIcon={<PlaceIcon />}
                disabled={!feature.canEditDeliverySitesOnboardingRequests()}
            />
        </Box>
);
}

export default observer(DeliverySitesOnboardingRequestsPanel);
